export enum MediaTypeEnum {
  Image = 'image',
  Video = 'video',
  Txt = 'txt',
  Word = 'word',
  Excel = 'excel',
  PowerPoint = 'powerpoint',
  Pdf = 'pdf',
  Other = 'other',
}
